import BaseEntity from 'client/components/core/BaseEntity/BaseEntityNew'
import ChildrenEntities from 'client/components/core/ChildrenEntities'
import CustomLoginContainerUi from 'client/components/entities/CustomLogin/ui/CustomLoginContainerUi'
import { CustomLoginModeEnum } from 'client/enums/custom-login-mode-enum'
import { useCustomLogin, usePage } from 'client/store'
import { selectors } from 'client/store/custom-login/customLoginReducer'
import pageSelectors from 'client/store/page/pageSelectors'
import CustomLoginInterface from 'common/types/entities/CustomLoginInterface'
import React, { createContext, useContext } from 'react'
import { EntityIdType } from 'src/shared/schemas/entity-id.schema'

type NewCustomLoginProps = {
  entity: CustomLoginInterface
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
}

const CustomLoginDescendantIdsContext = createContext([] as string[])

type CustomLoginDescendantIdsProviderProps = {
  children: React.ReactElement
  entityId: EntityIdType
}

export const useCustomLoginDescendantIds = () =>
  useContext(CustomLoginDescendantIdsContext)

function CustomLoginDescendantIdsProvider({
  children,
  entityId,
}: CustomLoginDescendantIdsProviderProps) {
  const descendantIds = usePage(page =>
    pageSelectors.getDescendantIds(page, entityId),
  ).concat([entityId])
  return (
    <CustomLoginDescendantIdsContext.Provider value={descendantIds}>
      {children}
    </CustomLoginDescendantIdsContext.Provider>
  )
}

function CustomLogin({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: NewCustomLoginProps) {
  const mode = useCustomLogin(selectors.getCustomLoginMode)

  let activeChildId: string
  switch (mode) {
    case CustomLoginModeEnum.Login:
      activeChildId = entity.childIds[0]
      break
    case CustomLoginModeEnum.Registration:
      activeChildId = entity.childIds[1]
      break
    case CustomLoginModeEnum.Request:
      activeChildId = entity.childIds[2]
      break
    case CustomLoginModeEnum.Reset:
      activeChildId = entity.childIds[3]
      break
    default:
      activeChildId = entity.childIds[0]
  }

  return (
    <BaseEntity
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <CustomLoginContainerUi
        padding={entity.padding}
        mobilePadding={entity.mobilePadding}
      >
        <CustomLoginDescendantIdsProvider entityId={entity.id}>
          <ChildrenEntities
            id={entity.id}
            type={entity.type}
            childIds={[activeChildId]}
          />
        </CustomLoginDescendantIdsProvider>
      </CustomLoginContainerUi>
    </BaseEntity>
  )
}

export default CustomLogin
